import { combineReducers } from 'redux';
import { 
    GRID_ITEMS, 
    SELECT_SUBREDDIT,
    INVALIDATE_SUBREDDIT,
    REQUEST_POSTS,
    RECEIVE_POSTS
} from '../actions/actions';

function selectedSubreddit(state = 'technews', action) {
    switch (action.type) {
      case SELECT_SUBREDDIT:
        return action.subreddit
      default:
        return state
    }
  }
  
  function posts(
    state = {
      isFetching: false,
      didInvalidate: false,
      items: []
    },
    action
  ) {
    switch (action.type) {
      case INVALIDATE_SUBREDDIT:
        return Object.assign({}, state, {
          didInvalidate: true
        })
      case REQUEST_POSTS:
        return Object.assign({}, state, {
          isFetching: true,
          didInvalidate: false
        })
      case RECEIVE_POSTS:
        return Object.assign({}, state, {
          isFetching: false,
          didInvalidate: false,
          items: action.posts,
          lastUpdated: action.receivedAt
        })
      default:
        return state
    }
  }
  
  function postsBySubreddit(state = {}, action) {
    switch (action.type) {
      case INVALIDATE_SUBREDDIT:
      case RECEIVE_POSTS:
      case REQUEST_POSTS:
        return Object.assign({}, state, {
          [action.subreddit]: posts(state[action.subreddit], action)
        })
      default:
        return state
    }
  }

var items = [
    {
        name: "Ryans Landscaping",
        type: "Website",
        link: "http://ryanslandscaping.co.uk/"
    },
    {
        name: "Bell Windows",
        type: "Website",
        link: "http://bell-windows.co.uk/"
    },
    {
        name: "James Purdy Architects",
        type: "Website",
        link: "http://jamespurdyarchitects.co.uk/"
    },
    {
        name: "Roomstyle Newcastle",
        type: "Website",
        link: "http://roomstylenewcastle.com/"
    },
    {
        name: "Annalong",
        type: "Website",
        link: "http://annalong.com/"
    },
    {
        name: "Galley Annalong",
        type: "Website",
        link: "http://thegalleyannalong.co.uk/"
    },
    {
        name: "Cornmill Quay",
        type: "Website Logo",
        link: "http://www.cornmillquay.org/"
    },
    {
        name: "A Robinson",
        type: "Website",
        link: "http://arobinson.co.uk/"
    },
    {
        name: "Intense Courses",
        type: "Website",
        link: "http://intensecourses.com/"
    },
    {
        name: "Swift Transport Training",
        type: "Website",
        link: "http://www.swifttransporttraining.com/"
    },
    {
        name: "Shimna Bowen Healing",
        type: "Website",
        link: "http://www.shimnabowenhealing.co.uk/"
    },
    {
        name: "Nauticomms",
        type: "Website Logo",
        link: "http://nauticomms.com/"
    },
    {
        name: "Archtec NI",
        type: "Website",
        link: "http://archtecni.co.uk/"
    },
    {
        name: "Harbour Inn Annalong",
        type: "Website",
        link: "https://www.harbourinnannalong.co.uk/"
    },
    {
        name: "Barbican Annalong",
        type: "Website",
        link: "http://www.barbicanannalong.co.uk/"
    },
];

const initialState = {
    gridItems: []
}

function grid(state = initialState, action) {
  switch (action.type) {
    case GRID_ITEMS:
        return Object.assign({}, state, {
            gridItems: items
        })
    default:
      return state
  }
}

const surfside = combineReducers({
  grid,
  postsBySubreddit,
  selectedSubreddit
})



export default surfside


// WEBPACK FOOTER //
// ./src/redux/reducers/reducers.js